import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import { useGetAttachedChannels } from '../../hooks'

import { dv360ChannelsWasLoadedSelector } from '../../../../../../../../modules/selectors/dv360Constants'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const ChannelsPreview = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const dv360ChannelsWasLoaded = useSelector(dv360ChannelsWasLoadedSelector)

  const { attachedChannels, excludedAttachedChannels } = useGetAttachedChannels()

  if (!dv360ChannelsWasLoaded) {
    return (
      <section className={classnames(drawerFormClasses.section, classes.channelsSection)}>
        <Skeleton count={4} />
      </section>
    )
  }

  return (
    <section className={classnames(drawerFormClasses.section, classes.channelsSection)}>
      {attachedChannels.length > 0 && (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Channels')}</h3>
          {attachedChannels.map(channel => (
            <p>{channel.name}</p>
          ))}
        </>
      )}

      {excludedAttachedChannels.length > 0 && (
        <>
          <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeChannelsTitle)}>
            {t('Excluded channels')}
          </h3>
          {excludedAttachedChannels.map(excludedChannel => (
            <p>{excludedChannel.name}</p>
          ))}
        </>
      )}
    </section>
  )
}

export default ChannelsPreview
